import {Controller} from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ['defaultHubspotEmailField', 'defaultHubspotPhoneField']
    static values = {
        type: String,
        index: String,
        fields: Array,
        selectedMappingField: String
    }

    connect() {}

    hubspotRemoveUsedFieldsController() {
        const controller = document.querySelector("[data-controller~='hubspot-remove-used-fields']")
        return this.application.getControllerForElementAndIdentifier(controller, "hubspot-remove-used-fields")
    }

    removeAlreadyMappedField() {
        this.hubspotRemoveUsedFieldsController().updateAllMappingFields();
    }
}
